import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateSportMapping } from "@/api/sportsNew";
import { SportsNewQueryKeys } from "@/tanstackQuery/queries/sportsNew";
import { UpdateSportMappingParams } from "@/types/ApiResponses/Sport";

export const useUpdateSportMapping = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: UpdateSportMappingParams) =>
      updateSportMapping(params),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [SportsNewQueryKeys.SportMappings, variables.sportId],
      });
    },
  });
};
